import actions from 'actions/assets/assetTolerances'
import { createChildFormViewContainer } from 'factories/ChildFormView'
import Component from 'components/Assets/Tolerances/FormView'

export default createChildFormViewContainer({ actions })(Component)
